import { createStore } from 'vuex'
import  cookies from 'vue-cookies'
import router from "@/router";

export default createStore({
  state: {
    isAuth: false,
    token: '',
    statusInformation: false,
  },
  getters: {
  },
  mutations: {
    onStart(state){
      const token =  cookies.get('token')
      if (token){
        state.isAuth = true
        state.token = token
      }else{
        state.isAuth = false
        state.token = ''
      }
    },
    login(state, token){
      if (token){
        state.isAuth = true
        state.token = token
        cookies.set('token', token, "3y")
      }else{
        state.isAuth = false
        state.token = ''
        cookies.remove('token')
      }
    },
    logout(state){
      state.isAuth = false
      state.token = ''
      cookies.remove('token')
      cookies.remove('is_mother')
      router.push('/')
    },
    setSharedList(state, newList) {
      state.statusInformation = newList;
      setTimeout(()=>{
        if (state.statusInformation){
          state.statusInformation=false
        }
      },1000)
    },

  },
  actions: {
  },
  modules: {
  }
})
